import z from 'zod'

import { transferListSchema } from 'components/Form/TransferList'
import { schema as globalSetupDefaultsMultiAnchorSchema } from 'features/globalSetup/pages/Defaults/RichPlacements/Sections/MultiAnchorSection/schema'
import { Domain } from 'features/inventory/types/domain'

export const MAX_ACTIVE_AD_UNITS: number = 8

export const schema = z
  .object({
    adUnitIds: transferListSchema.safeExtend({
      right: z.array(z.string()).max(MAX_ACTIVE_AD_UNITS),
    }),
    customizeAppearance: z.boolean().default(false),
    customizeBasicSettings: z.boolean().default(false),
    enabled: z.boolean().default(false),
  })
  .safeExtend(globalSetupDefaultsMultiAnchorSchema.shape)

export type Schema = z.infer<typeof schema>

export const schemaDefault = (domain: Domain): Schema => {
  const {
    domainRichPlacementMultiAnchor: {
      adUnitIds,
      customizeAppearance,
      customizeBasicSettings,
      customStyling,
      displayAfterUserInteraction,
      enabled,
      fullWidthMode,
      showCloseButton,
      singleAdViewTime,
    },
  } = domain

  return {
    adUnitIds: { left: [], right: adUnitIds },
    customizeAppearance,
    customizeBasicSettings,
    customStyling,
    displayAfterUserInteraction,
    enabled,
    fullWidthMode,
    showCloseButton,
    singleAdViewTime,
  }
}
